module.exports = __webpack_public_path__ + "img/astroid_gmt.ec48052c.gif";